import React from "react";
import { useGetUser } from "api/users/getUser";
import AdminDashboardPanel from "features/adminDashboard";
import EmployeeDashboardPanel from "features/employee-dashboard";
import DirectorDashboard from "features/director-dashboard/DirectorDashboard";

export default function AttendanceDashboardMain() {
  const { data: user, isLoading, error } = useGetUser();

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading user</div>;

  const role = user?.role;

  let content;
  if ((role as any) === "admin" || (role as any) === "superadmin") {
    content = <AdminDashboardPanel />;
  } else content = <EmployeeDashboardPanel />;

  return <div>{content}</div>;
}
